import { useOutlet } from "react-router-dom";

import TeamMemberSideBar from "../components/sideBar/TeamMemberSideBar";

export const Layout = () => {
  const outlet = useOutlet();

  return (
    <div>
      <TeamMemberSideBar />
      <div className="min-h-screen-calculated lg:pl-28">
        <main>{outlet}</main>
      </div>
    </div>
  );
};
